import type { RoofPerimeterRailType } from "building-types/roofs/roofPerimeterTypes";
import type { RoofSide } from "building-types/settings/roofTypes";
import type { NodeBSP } from "geom/bspTypes";
import type { PolyLine2 } from "geom/polyLine2Types";

export enum OverhangEdgeOverlap {
  NONE,
  PARTIAL,
  FULL,
}

export interface OverhangClippingCorner {
  readonly prevEdge: PolyLine2;
  readonly nextEdge: PolyLine2;
  readonly prevOverhang: number;
  readonly nextOverhang: number;
  readonly volume: NodeBSP | null;
}

export interface OverhangClippingEdge {
  readonly side: RoofSide;
  readonly type: RoofPerimeterRailType;
  readonly isStartEdge: boolean;
  readonly isEndEdge: boolean;
  readonly edge: PolyLine2;
  readonly baseEdge: PolyLine2;
  readonly overhang: number;
  readonly startHeight: number;
  readonly endHeight: number;
  readonly edgeVolume: NodeBSP | null;
  readonly extendedEdgeVolume: NodeBSP | null;
  readonly prevCorner?: OverhangClippingCorner;
  readonly nextCorner?: OverhangClippingCorner;
}

export function overhangClippingCornerNew(
  prevEdge: PolyLine2,
  nextEdge: PolyLine2,
  prevOverhang: number,
  nextOverhang: number,
  volume: NodeBSP | null,
): OverhangClippingCorner {
  return {
    prevEdge,
    nextEdge,
    prevOverhang,
    nextOverhang,
    volume,
  };
}

export function overhangClippingEdgeNew(
  side: RoofSide,
  type: RoofPerimeterRailType,
  isStartEdge: boolean,
  isEndEdge: boolean,
  edge: PolyLine2,
  baseEdge: PolyLine2,
  overhang: number,
  startHeight: number,
  endHeight: number,
  edgeVolume: NodeBSP | null,
  extendedEdgeVolume: NodeBSP | null,
  prevCorner?: OverhangClippingCorner,
  nextCorner?: OverhangClippingCorner,
): OverhangClippingEdge {
  return {
    side,
    type,
    isStartEdge,
    isEndEdge,
    edge,
    baseEdge,
    overhang,
    startHeight,
    endHeight,
    edgeVolume,
    extendedEdgeVolume,
    prevCorner,
    nextCorner,
  };
}
